import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { UserContext } from "context/user";
import { fetchStackBasePrice } from "api/Cart";

export const useStackBasePriceQuery = () => {
  const { token } = useContext(UserContext);

  return useQuery(["stackPricing", token], () => fetchStackBasePrice(token));
};
